import { apiClient } from "./client";

// Tipos backend: 1=Aluno, 2=Responsavel, 3=Coordenador, 4=Admin
export const TipoUsuario = {
  Aluno: 1,
  Responsavel: 2,
  Coordenador: 3,
  Admin: 4,
};

const NUM_TO_LABEL = {
  1: "aluno",
  2: "responsavel",
  3: "coordenador",
  4: "admin",
};
const LABEL_TO_NUM = { aluno: 1, responsavel: 2, coordenador: 3, admin: 4 };

// Aceita number (1-4) ou string ("aluno"|"Aluno"|"admin") e retorna label canônico em lowercase.
export function tipoNumeroParaLabel(valor) {
  if (typeof valor === "number") return NUM_TO_LABEL[valor] || null;
  const norm = String(valor || "").toLowerCase();
  return LABEL_TO_NUM[norm] ? norm : null;
}

export function tipoLabelParaNumero(label) {
  const norm = String(label || "").toLowerCase();
  return LABEL_TO_NUM[norm] || null;
}

const LABEL_BONITO = {
  aluno: "Aluno",
  responsavel: "Responsável",
  coordenador: "Coordenador",
  admin: "Administrador",
};

export function formatarTipoUsuario(valor) {
  const label = tipoNumeroParaLabel(valor);
  return label ? LABEL_BONITO[label] : "—";
}

export const obterUsuarioAtual = () => apiClient.get("/usuarios/me");

// Cores das turmas (a "bolinha"), por usuário, sincronizadas entre dispositivos.
export const listarCoresTurmas = () =>
  apiClient.get("/usuarios/me/cores-turmas");
export const definirCorTurma = (turmaId, cor) =>
  apiClient.put(`/usuarios/me/cores-turmas/${turmaId}`, { cor });
export const listarUsuarios = (instituicaoId) => {
  const qs = instituicaoId ? `?instituicaoId=${instituicaoId}` : "";
  return apiClient.get(`/usuarios${qs}`);
};

export const criarUsuario = (payload) => apiClient.post("/usuarios", payload);
export const editarUsuario = (id, payload) =>
  apiClient.put(`/usuarios/${id}`, payload);
export const redefinirSenha = (id, novaSenha) =>
  apiClient.post(`/usuarios/${id}/redefinir-senha`, { userId: id, novaSenha });
export const desativarUsuario = (id) => apiClient.delete(`/usuarios/${id}`);
export const aceitarTermos = () =>
  apiClient.post("/usuarios/me/aceitar-termos");
export const alterarSenhaPropria = (senhaAtual, novaSenha) =>
  apiClient.post("/usuarios/me/senha", { senhaAtual, novaSenha });
